import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import Spin from 'components/Spin';
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import {
  getCardsForConnectPoint,
  getConnectPoints,
} from 'services/connect-card.service';
import ConnectPoint from '../../components/ConnectPoint';
import getTheme from '../../utils/getTheme';

const ConnectPointPage = ({ match }) => {
  const [data, setData] = useState();
  const [cards, setCards] = useState([]);
  const account = useSelector((s) => s.settings.account);

  useEffect(() => {
    getConnectPoints({
      hash: match.params.id,
      load_account: 1,
      account_id: account.account_id,
    }).then((resp) => {
      setData(resp[0]);
    });
    getCardsForConnectPoint(match.params.id).then(async (resp) => {
      setCards(resp);
    });
  }, []);

  if (!data) return <Spin spinning />;

  const theme = getTheme({
    primary: data.primary_color,
    text: data.collection_text_color,
  });

  return (
    <>
      <Helmet titleTemplate={`%s - ${data.account.account_name}`} de>
        <title>{data.collection_title}</title>
        <meta property="description" content={data.collection_description} />
        <meta property="og:title" content={data.collection_title} />
        <meta property="og:description" content={data.collection_description} />
        <meta property="og:image" content={data.logo_or_video_url} />
      </Helmet>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ConnectPoint data={data} cards={cards} />
      </ThemeProvider>
    </>
  );
};

export default ConnectPointPage;
